<h4>Conferenze CIFRIS</h4>
<div class="cards">
	<mat-card class="card" [routerLink]="'/cifris25'">
		<img mat-card-image src="../../../../assets/images/events/2025/cifris25/roma.jpg" alt="Congresso CIFRIS25">
		<div class="container">
			<h1 class="mat-headline" style="background-color: var(--cifris_green);">Congresso CIFRIS25</h1>
		</div>
	</mat-card>
	<mat-card class="card" [routerLink]="'/cifris24'">
		<img mat-card-image src="../../../../assets/images/events/2024/cifris24/roma.webp" alt="Congresso CIFRIS24">
		<div class="container">
			<h1 class="mat-headline" style="background-color: var(--cifris_green);">Congresso CIFRIS24</h1>
		</div>
	</mat-card>
	<mat-card class="card" [routerLink]="'/cifris23'">
		<img mat-card-image src="../../../../assets/images/events/2024/cifris24/roma2.jpg" alt="Congresso CIFRIS23">
		<div class="container">
			<h1 class="mat-headline" style="background-color: var(--cifris_green);">Congresso CIFRIS23</h1>
		</div>
	</mat-card>
</div>

<h4>EVENTI 2026</h4>
<ul>
	<li>
		<b> Eventi patrocinati:</b>
		<ul>
			<li>
   				 <a class="event" routerLink="/attivita/eventi/yamc">
        				Young Applied Mathematicians Conference 2026
   				 </a>,
			</li>
			<li>
				<a class="event" routerLink="/attivita/eventi/histo26">
					HisTO26 - History of Cryptography in Turin
				</a>, 
			</li>
			<li>
				<a class="event" routerLink="/attivita/eventi/magic2026">
					MaGIC 2026 - Marche Workshop on Group Actions in Cryptography
				</a>, 
			</li>
		</ul>
	</li>
</ul>


<h4>EVENTI 2025</h4>
<ul>
	<li>
		<a [routerLink]="['/ixh25']"> IXH25</a>, secondo hackathon nazionale.
	</li>
	<li>
		<a [routerLink]="['/pqcifris25']"> PQCifris25</a>, incontro nazionale sulla migrazione al post-quantum.
	</li>
	<li>
		<a [routerLink]="['/fcir25']"> FCIR25</a>, crittografia finanziaria a Roma.
	</li>
	<li>
		<a [routerLink]="['/cifris25']"> CIFRIS25</a>, congresso Italiano di crittografia.
		Rivolto a tutta la comunità italiana: da esperti ad interessati.
	</li>
</ul>
<h4>EVENTI 2024</h4>
<ul>
	<li>
		<a [routerLink]="['/cifris24']"> CIFRIS24</a>, il secondo congresso Italiano di crittografia.
		Rivolto a tutta la comunità italiana: da esperti ad interessati.
	</li>
	<li>
		<a [routerLink]="['/ixh24']"> IXH24</a>,
		il nostro primo hackathon nazionale, nell'eterna Roma. Dal 21 al 23
		Novembre 2024.
	</li>
	<li>
		 <b>10 Maggio 2024</b>, <a href="https://www.linkedin.com/posts/de-cifris-associazione-nazionale-8274501a5_locandina-evento-imprese-crittografia-activity-7183528855704391682-kS3K?originalSubdomain=it">incontro alla Camera dei Deputati</a> dal titolo Crittografia e Imprese per il Paese per incentivare la collaborazione tra le Istituzioni e le imprese più innovative.

	</li>
	<li>
		<b>15 Marzo 2024 - 10:00</b>, evento Eruditorum 2024 <i>"la Crittografia nella società, tra Storia e
			Diritto"</i> <br>
		In collaborazione con il Dipartimento di Giurisprudenza UniTN<br>
		<a href="https://webmagazine.unitn.it/evento/giurisprudenza/119927/de-cifris-eruditorum-2024">Webmagazine
			UniTN</a>,
		<a href="https://www.linkedin.com/feed/update/urn:li:activity:7171887617716817920/">post LinkedIn</a>
		<ul>
			<li>
				<b style="color:black">10:00 - 10:30, Introduzione e saluti istituzionali</b><br>
				Massimiliano Sala -- presidente De Componendis Cifris APS <br>
				Paolo Carta -- presidente della Facoltà di Giurisprudenza UniTN <br>
			</li>
			<li>
				<b style="color:black">10:30 - 11:30, Storia della crittografia</b><br>
				<ul>
					<li>
						Paolo Bonavoglia -- De Componendis Cifris<br>
						<i>Franceschi - Partenio, una disputa crittografica nel Rinascimento</i> (<a
							href="../../../assets/eventi/2024/Eruditorum 2024/Franceschi vs Partenio-1.pdf">Slides</a>)
					</li>
					<li>
						Marco Moraglio -- Università dell'Insubria<br>
						<i>Scrivere per nascondere, leggere per scoprire. Le origini della crittografia</i> (<a
							href="../../../assets/eventi/2024/Eruditorum 2024/Scrivere per nascondere, leggere per scoprire.pdf">Slides</a>)
					</li>
					<li>
						Cosimo Palma -- Università di Pisa<br>
						<i>Epigrafi cifrate nelle chiese antiche</i> (<a
							href="../../../assets/eventi/2024/Eruditorum 2024/presentazioneDeCiphrisEruditorum2024_Palma.pdf">Slides</a>)
					</li>
				</ul>
			</li>
			<li>
				<b style="color:black">11:45 - 13:00, Crittografia e diritto</b><br>
				<ul>
					<li>
						Marcello Albergoni -- Agenzia per la Cybersicurezza Nazionale<br>
						<i>La crittografia come strumento di cybersicurezza e per l’autonomia strategica
							nazionale</i><br>
					</li>
					<li>
						Antonino Alì -- Università di Trento<br>
						<i>Crittografia e Stato: tra privacy e sicurezza collettiva</i> (<a
							href="../../../assets/eventi/2024/Eruditorum 2024/Telegram - crittografia.pdf">Slides</a>)
					</li>
				</ul>
			</li>
		</ul>
	</li>
	<li>
		<b> Eventi patrocinati:</b>
		<ul>
			<li>
				<a class="event" href="https://crypto.polito.it/cryptography_days">
					CrypTography Days 2024
				</a>, gruppo "CrypTo" del Politecnico di Torino
			</li>
			<li>
				<a class="event" href="https://www.math.univ-paris13.fr/~borello/OpeRa2024/main.html">
					Open Problems on Rank-Metric Codes (OpeRa) 2024
				</a>, University of Campania "Luigi Vanvitelli"
			</li>
			<li>
				<a class="event" href="https://wcc2024.sites.dmi.unipg.it/">
					The Thirteenth International Workshop on
					Coding and Cryptography - WCC24
				</a>, Perugia, dal 17 giugno al 21 giugno
			</li>
			<li>
				<a class="event" href="https://sites.google.com/view/combinatorics2024/">
					Combinatorics24
				</a>, Bari, dal 3 al 7 giugno
			</li>
		</ul>
	</li>
</ul>
<h4>EVENTI 2023</h4>
<ul>
	<li>
		<a [routerLink]="['/cifris23']"> CIFRIS23</a>, il primo congresso Italiano di crittografia.
		Rivolto a tutta la comunità italiana: da esperti ad interessati.
	</li>
	<li>
		 <b>17 Aprile 2023</b>, <a href="https://www.linkedin.com/posts/de-cifris-associazione-nazionale-8274501a5_locandina-finale-centro-nazionale-di-crittografia-activity-7052278482076147712-8MDu">incontro alla Camera dei Deputati</a> per discutere il ruolo che un centro nazionale di crittografia potrebbe avere per il nostro Paese.

	</li>
	<li>
		<b> Eventi patrocinati:</b>
		<ul>
			<li>
				<a class="event" href="https://sites.google.com/view/crittografiaecodici/convegno-2023">
					Convegno di Crittografia e Codici 2023
				</a>
				, Perugia, gruppo UMI "Crittografia e Codici"
			</li>
			<li>
				<a class="event" href="https://st.fbk.eu/events/TDI2023/">
					First International Workshop in Digital Identity 2023
				</a>, Trento
			</li>
		</ul>
	</li>
</ul>
<h4>EVENTI 2022</h4>
<ul>
	<li>
		Tra il 10 e il 14 ottobre 2022 si è svolto <a [routerLink]="['/attivita/pqcifris-summer22']">PQCifris 2022</a>,
		che ha riunito studenti e ricercatori interessati alla crittografia post-quantistica,
		proponendo due giornate di Scuola e due di Workshop, per introdurre l'argomento,
		presentare i temi più all'avanguardia e discutere i recenti progressi della
		ricerca attuale.
	</li>
	<li>
		Tra il 2 e il 27 maggio 2022, in collaborazione con 13 atenei Nazionali e Internazionali
		si è svolto il corso on line <a [routerLink]="['/trends']">Trends in Modern Cryptography</a>,
		relativo ad aspetti crittografici come
		la crittografia post quantum e la crittografia su cloud.
	</li>
</ul>
<h4>EVENTI 2021</h4>
<ul>
	<li>
		<a routerLink="/cryptowars/2021">Cryptowars 2021</a>.
	</li>
	<li>
		In collaborazione con il gruppo di Crittografia e Codici dell'UMI nei giorni 21-22
		settembre si è tenuto il <a href="/convegnoUmi">convegno annuale</a> di crittografia e teoria dei
		codici, in cui i
		ricercatori hanno presentato i loro risultati e le novità dell'intera comunità crittografica.
	</li>
</ul>
<h4>EVENTI 2020</h4>
<ul>
	<li><a routerLink="/cryptowars/2020">Cryptowars 2020</a>.</li>
	<li>
		<a href="../../../assets/eventi/2020/RomaAntica/DC-Historiae-Moraglio.pdf">
			Codici segreti nella Roma antica</a> (6 novembre 2020) - <a href="../../../assets/eventi/
					2020/RomaAntica/MORAGLIO-slide.pdf">slide</a>.
	</li>
	<li>
		<a style="color:#1380ed;" class="toggleText" (click)="mostraEvento
				('workshopCryptanalysis')">Workshop</a>: Cryptanalysis: a key tool in
		securing and breaking ciphers
		(4 febbraio).
	</li>
	<div *ngIf="eventoDaMostrare=='workshopCryptanalysis'">
		<app-workshop-cryptanalysis></app-workshop-cryptanalysis>
	</div>
	<li>
		<a href="https://scn.unisa.it/scn20/">
			12th Conference on Security and Cryptography for Networks
		</a> (14-16 settembre).
	</li>
</ul>
<h4>EVENTI 2019</h4>
<ul>
	<li><a routerLink="/cryptowars/2019">Cryptowars 2019</a>.</li>
	<li><a style="color:#1380ed;" class="toggleText" (click)="mostraEvento('torinoOttobre')">
			Evento De Cifris Nord Italia</a>
		(Torino 14 ottobre).
	</li>
	<div *ngIf="eventoDaMostrare=='torinoOttobre'">
		<app-sessione-torino></app-sessione-torino>
	</div>
	<li>
		<a style="color:#1380ed;" class="toggleText" (click)="mostraEvento('perugia')">
			Evento De Cifris Centro-Sud Italia
		</a>(Perugia 16 ottobre).
	</li>
	<div *ngIf="eventoDaMostrare=='perugia'">
		<app-sessione-perugia></app-sessione-perugia>
	</div>
	<li>
		<a style="color:#1380ed;" class="toggleText" (click)="mostraEvento('hackatonSmartContract')">
			Prima Hackaton
		</a> De Cifris di Smart Contract (26 settembre).
	</li>
	<div *ngIf="eventoDaMostrare=='hackatonSmartContract'">
		<app-hackaton-smart-contract></app-hackaton-smart-contract>
	</div>
	<li>
		Creazione dei cicli di <a href="/seminariLocali">seminari</a>.</li>
	<li>Le <a href="/opportunita">borse di studio</a> dell'Advisory Board. </li>
	<li><a href="/attivita">Le 100 tesi</a>.</li>
	<li>Evento di crittografia militare in collaborazione con AFCEA (Roma 8 maggio) .</li>
	<li>
		Primo evento del neocostituito team di PostQuantum:
		<a style="color:#1380ed;" class="toggleText" (click)="mostraEvento('romaPQCifris')">PQCifris2019</a>
		(Roma 9 maggio).
	</li>
	<div *ngIf="eventoDaMostrare=='romaPQCifris'">
		<app-sessione-roma-pqcifris></app-sessione-roma-pqcifris>
	</div>
	<li>Seconda edizione dell'evento del team di Blockchain:
		<a style="color:#1380ed;" class="toggleText" (click)="mostraEvento('romaCifrisChain')">
			Cifris Chain 2019
		</a> (Roma 9 maggio).
	</li>
	<div *ngIf="eventoDaMostrare=='romaCifrisChain'">
		<app-sessione-roma-cifrischain></app-sessione-roma-cifrischain>
	</div>
</ul>
<h4>EVENTI 2018</h4>
<ul>
	<li><a routerLink="/cryptowars/2018">Cryptowars 2018</a>.</li>
	<li>I nostri eventi territoriali:
		<ul>
			<li>
				<a style="color:#1380ed;" class="toggleText" (click)="mostraEvento('salerno')">
					De Cifris a Salerno</a> (9 maggio).
			</li>
			<div *ngIf="eventoDaMostrare=='salerno'" style="width: 100%;">
				<app-sessione-salerno></app-sessione-salerno>
			</div>
			<li>
				<a style="color:#1380ed;" class="toggleText" (click)="mostraEvento('milano')">
					De Cifris a Milano</a> (11 settembre).
			</li>
			<div *ngIf="eventoDaMostrare=='milano'">
				<app-sessione-milano></app-sessione-milano>
			</div>
			<li>
				<a style="color:#1380ed;" class="toggleText" (click)="mostraEvento('roma')">
					De Cifris a Roma</a> (4 ottobre).
			</li>
			<div *ngIf="eventoDaMostrare=='roma'">
				<app-sessione-roma></app-sessione-roma>
			</div>
		</ul>
	</li>
	<li>I nostri eventi tematici:
		<ul>
			<li>
				<a style="color:#1380ed;" class="toggleText" (click)="mostraEvento('eventoConoscitivo')">
					Evento conoscitivo De Componendis Cifris</a> (22 gennaio).
			</li>
			<div *ngIf="eventoDaMostrare=='eventoConoscitivo'">
				<app-evento-conoscitivo></app-evento-conoscitivo>
			</div>
			<li>
				<a style="color:#1380ed;" class="toggleText" (click)="mostraEvento('itasec')">
					Evento De Cifris: ITASEC 2018</a> (8 febbraio).
			</li>
			<div *ngIf="eventoDaMostrare=='itasec'">
				<app-itasec></app-itasec>
			</div>
			<li>
				<a style="color:#1380ed;" class="toggleText" (click)="mostraEvento('eventoCifrisChain')">
					Evento Cifris Chain
				</a> (17 dicembre).
			</li>
			<div *ngIf="eventoDaMostrare=='eventoCifrisChain'">
				<app-evento-cifrischain></app-evento-cifrischain>
			</div>
		</ul>
	</li>
</ul>